export default function Title({ children }) {
  return <h1 className="mx-2 mt-4">{children}</h1>
}
